import { Component, Input, Output, EventEmitter, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-award-card',
  templateUrl: './award-card.component.html',
  styleUrl: './award-card.component.scss'
})
export class AwardCardComponent {
  @Input() awardName: string;
  @Input() awardDescription: string;
  @Input() coinAmount: string;
  @Input() xpQuantity: string;
  @Input() imageUrl: string;
  @Input() awardPeriod: string;
  @Input() isUnlimited?: boolean;
  @Input() awardLimit: number;
  @Input() awardCount: number;
  @Input() updateSuccess: boolean;
  @Input() isGivingAward: boolean;
  @Output() giveAwardClick: EventEmitter<any> = new EventEmitter();

  constructor(private cdr: ChangeDetectorRef, private localizationService: CVLocalizationService,) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['updateSuccess'] && changes['updateSuccess'].currentValue === true) {
      this.getAwardCount();
      this.cdr.detectChanges();
    }
  }

  getAwardCount(): string {
    if (this.isUnlimited && this.awardLimit === 0) {
      return `${this.localizationService.getCachedText("Manual_Awards_Context_Menu", "Unlimited", "Unlimited")}`;
    } else if (this.awardLimit !== undefined && this.awardCount !== undefined) {
      const remainingAwards = this.awardLimit - this.awardCount;
      return `${remainingAwards} ${this.localizationService.getCachedText("Manual_Awards_Context_Menu", "Remaining", "Remaining")}`;
    }
    return `0 ${this.localizationService.getCachedText("Manual_Awards_Context_Menu", "Remaining", "Remaining")}`;
  }

  isButtonDisabled(): boolean {
    if (this.isUnlimited) {
      return false;
    }
    return this.awardLimit !== undefined && this.awardCount !== undefined &&
      (this.awardLimit - this.awardCount) <= 0;
  }

  getAwardPeriodMessage(): string {
    if (this.isUnlimited) {
      return "";
    } else {
      const periodMessages: { [key: string]: string } = {
        Week: this.localizationService.getCachedText("Manual_Awards_Context_Menu", "Resets_Weekly", "Resets Weekly"),
        Month: this.localizationService.getCachedText("Manual_Awards_Context_Menu", "Resets_Monthly", "Resets Monthly"),
        Quarter: this.localizationService.getCachedText("Manual_Awards_Context_Menu", "Resets_Quarterly", "Resets Quarterly"),
        AllTime: this.localizationService.getCachedText("Manual_Awards_Context_Menu", "Never_Resets", "Never Resets")
      };

      return periodMessages[this.awardPeriod] || this.awardPeriod;
    }
  }

  giveAward() {
    this.giveAwardClick.emit();
  }
}